<template>
    <div>
        <div class="own-input">
            <label for="name">{{ $t('f_name_label') }}</label>
            <info-tip :text="$t('f_name_tip_text')" />
            <input
                id="name"
                v-model="name"
                v-validate="'required|name'"
                v-m-android-focus
                v-normalize
                v-capitalize
                name="name"
                :placeholder="$t('f_name_placeholder')"
                type="text"
                :data-vv-scope="scope">
            <span class="error-message">{{ errors.first(`${scope}.name`) }}</span>
        </div>
        <div class="own-input email">
            <label for="email">{{ $t('f_email_label') }}</label>
            <info-tip :text="$t('f_email_tip_text')" />
            <input
                id="email"
                ref="email"
                v-model="email"
                v-validate="'required|email'"
                v-m-android-focus
                v-normalize
                name="email"
                placeholder="your@email.com"
                type="email"
                :data-vv-scope="scope">
            <span class="error-message">{{ errors.first(`${scope}.email`) }}</span>
            <div v-if="confirm_email_required">
                <label for="confirm_email">{{ $t('f_email_confirmation_label') }}</label>
                <input
                    id="confirm_email"
                    v-model="confirm_email"
                    v-validate="'required|confirmed:email'"
                    v-m-android-focus
                    v-normalize
                    name="confirm_email"
                    placeholder="your@email.com"
                    type="email"
                    data-vv-as="email"
                    :data-vv-scope="scope">
                <span class="error-message">{{ errors.first(`${scope}.confirm_email`) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'

const { mapFields } = createHelpers({
  getterType: 'round1/getComplaintField',
  mutationType: 'round1/UPDATE_COMPLAINT_FIELD'
})

export default {
  props: {
    scope: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapFields([
      'name',
      'email',
      'confirm_email',
      'confirm_email_required'
    ])
  }
}
</script>